import React from "react";

export type FdPlaceholderVariant = "phone" | "phones-dual" | "screen" | "banner";

interface FdImagePlaceholderProps {
  label: string;
  hint?: string;
  variant?: FdPlaceholderVariant;
  className?: string;
}

const PlaceholderIcon: React.FC<{ variant: FdPlaceholderVariant }> = ({ variant }) => {
  if (variant === "phones-dual") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="8" y="6" width="18" height="32" rx="3" stroke="currentColor" strokeWidth="1.5" />
        <rect x="22" y="10" width="18" height="32" rx="3" stroke="currentColor" strokeWidth="1.5" opacity="0.7" />
      </svg>
    );
  }

  if (variant === "phone") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="14" y="4" width="20" height="40" rx="4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M20 38h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }

  if (variant === "banner") {
    return (
      <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <rect x="4" y="10" width="40" height="28" rx="4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 18h40" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="14" r="2" fill="currentColor" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <rect x="6" y="8" width="36" height="32" rx="4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M6 16h36" stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="22" width="14" height="4" rx="1" fill="currentColor" opacity="0.35" />
      <rect x="10" y="30" width="22" height="3" rx="1" fill="currentColor" opacity="0.25" />
    </svg>
  );
};

const FdImagePlaceholder: React.FC<FdImagePlaceholderProps> = ({
  label,
  hint,
  variant = "screen",
  className = "",
}) => {
  return (
    <div
      className={`fd-placeholder fd-placeholder--${variant} ${className}`.trim()}
      role="img"
      aria-label={`${label}${hint ? ` — ${hint}` : ""}`}
    >
      <div className="fd-placeholder__frame">
        <span className="fd-placeholder__icon">
          <PlaceholderIcon variant={variant} />
        </span>
        <span className="fd-placeholder__label">{label}</span>
        {hint && <span className="fd-placeholder__hint">{hint}</span>}
      </div>
    </div>
  );
};

export default FdImagePlaceholder;
